import { HTTPRequestMethods } from "../../Shared/httpRequestMethods";
import { convertObjectKeysToSnakeCase } from "../../Shared/ConvertObjectKeysToSnakeCase";
import { parseJsonResponse } from "../../Shared/parseJsonResponse";

export const getResume = ({ resumeId, onResponse, onError }) => {
  fetch(
    `/api/resumes/${resumeId}`,
    {
      method: HTTPRequestMethods.GET,
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const saveResume = ({ resumeId, onResponse, onError, body }) => {
  fetch(
    `/api/resumes/${resumeId}`,
    {
      method: HTTPRequestMethods.PUT,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(convertObjectKeysToSnakeCase(body)),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const downloadResumePdf = ({ resumeId, onError }) => {
  fetch(
    `/api/resumes/${resumeId}/download_pdf`,
    {
      method: HTTPRequestMethods.GET,
    }
  )
  .then(response => {
    if (!response.ok) {
      return response.json().then(data => {
        onError({
          feedbackMessage: data.feedbackMessage || "Failed to download PDF.",
          feedbackVariant: "error",
        });
      });
    }

    const contentDisposition = response.headers.get('Content-Disposition');
    let filename = 'Resume.pdf';
    if (contentDisposition) {
      const match = contentDisposition.match(/filename="?([^";\n]+)"?/);
      if (match) filename = match[1];
    }

    return response.blob().then(blob => {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};
